import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/OS logo inverted.png';
import mailIcon from './assets/mail-icon.png';
import instagramIcon from './assets/instagram-icon.png';
import './ConstitutionPage.css';

function NewsletterPage() {

  return (
    <div className="NewsletterPage">
      <header className="Newsletter-header">
        <Link to="/" className="logo-link">
          <img src={logo} className="Newsletter-logo" alt="logo" />
        </Link>
        <h1>Information for artists</h1>
        
        <p>
          Outer Spaces is dedicated to documenting and celebrating the Sheffield music scene by recording
          unique live sessions in interesting spaces. We focus on original material performed live by the artists.
        </p>

        <p>Artist will never be charged for the service.</p>

        <p>The final recorded sessions will be released on the Outer Spaces channel <i>not</i> on the artists own platforms. Artist are welcome to request the audio or video for their own use but Outer Spaces retains the right to refuse. Artist also retaint he right to request the videos are removed from the channel if they wish.</p>

        <p>The sessions work best when the artists are involved in the planning of the session and provide suggestions for locations they think will suit their music and style.</p>



        <div className="social-links">
          <a href="mailto:contact@example.com" className="mail-link">
            <img src={mailIcon} alt="Mail Icon" className="mail-icon" />
          </a>
          <a
            href="https://www.instagram.com/outer_spaces_sessions/"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-link"
          >
            <img
              src={instagramIcon}
              alt="Instagram Icon"
              className="instagram-icon"
            />
          </a>
        </div>

        <Link to="/" className="back-link">
          ← Back to Sessions
        </Link>
      </header>
    </div>
  );
}

export default NewsletterPage;
